import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { debounce } from '../../Utils';
import '../../styles/Common/DropDownV4.scss'
import { Radio } from '@mui/material';
import { Arrow } from '../../assets/Icons/ArrowIcons';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
const DropDownV4 = (props) => {
    const { width = '100%',
        disabled = false,
        label = '',
        id = '',
        searchPlaceholder = label,
        option = [],
        Icon = null,
        closeIcon = false,
        primaryKey = '',
        labelKey = '',
        preSelectedValues = [],
        onKeyDown = () => { },
        onSelect = () => { },
        multiSelect = false,
        isObject = false,
        SearchIcon = null
    } = props
    const listRef = useRef(null);
    const dropRef = useRef(null)
    const [displayValue, setDisplayValue] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [selectedValues, setSelectedValues] = useState(preSelectedValues);
    const uniqueOptions = useMemo(() => {
        if (!Array.isArray(option)) {
            console.warn('Option prop is not an array.');
            return [];
        }
        return Array.from(
            new Map(option.map((obj) => [obj[primaryKey], obj])).values()
        );
    }, [option, primaryKey]);

    useEffect(() => {
        setFilteredOptions(uniqueOptions);
    }, [uniqueOptions]);

    useEffect(() => {
        setSelectedValues(preSelectedValues);
        if (multiSelect) {
            if (!isObject && preSelectedValues?.length > 1) {
                setDisplayValue(`All ${label}`)
            } else {
                setDisplayValue(preSelectedValues.map(item => item[labelKey]).join(','));
            }
        } else if (preSelectedValues.length > 0) {
            setDisplayValue(preSelectedValues[0][labelKey]);
        } else {
            setDisplayValue(null);
        }
    }, [preSelectedValues, uniqueOptions, label, primaryKey, labelKey, multiSelect]);

    const updateSearchTerm = useCallback(
        debounce((term) => {
            setFilteredOptions(
                uniqueOptions.filter((obj) =>
                    obj[labelKey]?.toLowerCase().includes(term.toLowerCase())
                )
            );
        }, 100),
        [labelKey, uniqueOptions]
    );

    const handleSearchChange = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        updateSearchTerm(term);


       
    };
    const openModal = () => {
        if (!disabled) {
            setIsModalOpen(true);
        }
    };
    const closeModal = () => {
        setIsModalOpen(false)
        setSearchTerm('')
    };


    const handleItemClick = useCallback(
        (item) => {
            let newSelectedValues;
            if (multiSelect) {
                const isSelected = selectedValues.some(selected => selected[primaryKey] === item[primaryKey]);
                newSelectedValues = isSelected
                    ? selectedValues.filter(selected => selected[primaryKey] !== item[primaryKey])
                    : [...selectedValues, item];
                setSelectedValues(newSelectedValues);
                if (!isObject && newSelectedValues?.length > 1) {
                    setDisplayValue(`All ${label}`)
                } else {
                    setDisplayValue(newSelectedValues.map(selected => selected[labelKey]).join(', '));
                }
            } else {
                newSelectedValues = [item];
                setSelectedValues(newSelectedValues);
                setDisplayValue(item[labelKey]);
                closeModal();
            }
            onSelect(newSelectedValues);
            setSearchTerm('')
        },
        [multiSelect, selectedValues, primaryKey, labelKey, onSelect]
    );

   

    const RowRenderV1 = ({ obj }) => {
        const isSelected = selectedValues.some(item => item[primaryKey] === obj[primaryKey]);
        return (<li
            onClick={() => handleItemClick(obj)}

        >
            {multiSelect ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Radio
                        checked={isSelected}
                        name={obj[primaryKey]}
                        inputProps={{ 'aria-label': obj[labelKey] }}
                        icon={<CheckBoxOutlineBlankIcon />}  // Default icon
                        checkedIcon={<CheckBoxIcon />}
                        sx={{ padding: '0px 5px 0px 0px' }}
                    />
                    {obj[labelKey]}
                    {/* <div style={{ display: 'flex', alignItems: 'center', flex: 1, wordBreak: 'break-word', padding: '0 8px' }} >
                                    <span style={{ flex: 1 }}>{obj[labelKey]}</span>
                                </div> */}
                </div>
            ) : (
                obj[labelKey]
            )}

        </li>
        )
    }
   

    return (
        <div
            className={`dropdownV4--wrapper  ${disabled ? "disable" : ""}`}
            style={{ width: width }}
        >
            <div
                ref={dropRef}
                className={`input-wrapper ${Icon ? 'with-start-icon' : ''} ${closeIcon ? 'with-end-icon' : ''}`}>
                {Icon && <Icon className='start--icon' />}
                <div className={`inp--label `} style={{ width: `${dropRef?.current !== null ? dropRef?.current?.clientWidth - 24 : 0}px` }}>
                    {label}
                </div>
                <input
                    type="text"
                    className={`inp--field ${displayValue === null || displayValue === '' ? '' : 'filled'}`}
                    value={displayValue === null || displayValue === '' ? '' : displayValue}
                    readOnly
                    id={id}
                    placeholder={`Select ${searchPlaceholder}`}
                    onKeyDown={onKeyDown}
                    onClick={openModal}
                />
                <div className='arrow-icon'>
                    <Arrow width={13} height={7} />
                </div>
                {/* {(closeIcon && (displayValue !== null && displayValue !== '')) &&
                    <CloseIcon className='cross--icon--inp' onClick={() => {
                        setDisplayValue(null)
                        setSelectedValues([]);
                        closeModal()
                        onSelect([])
                    }} />
                } */}

            </div>
            {isModalOpen && (
                <div className="modal--overlay" onClick={closeModal}>
                    <div className="modal--content" onClick={(e) => e.stopPropagation()}>
                        <div className='modal-header'>
                            <ArrowBackIcon onClick={closeModal} style={{ color: '#fff', width: '30px', height: '30px' }} />
                            <span className="header-text">{label}</span>
                        </div>
                        <div style={{ padding: '12px 16px', background: '#fff' }}>
                            <div className="drop--search">
                                {SearchIcon != null && <div className='search--icon'>
                                    {SearchIcon}
                                </div>
                                }
                                <input
                                    name={''}
                                    type="text"
                                    className="search"
                                    placeholder={searchPlaceholder}
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    onKeyDown={(e) => { }}
                                    autoFocus
                                    autoComplete={"off"}
                                />
                            </div>
                        </div>
                        <div className='list-header'>
                            <span>Or select from below list</span>
                        </div>
                        <ul className='dropdown--list'>
                            {filteredOptions.map((obj) => (
                                <RowRenderV1 obj={obj} />
                            ))}
                        </ul>

                    </div>
                </div>
            )
            }
        </div>
    )
}

export default DropDownV4